import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

// Shown in place of the testimonials until real customer reviews are added to data/testimonials.ts
const benefits = [{
  title: 'Clear visual explanations',
  text: 'Make machine settings, arc control, gun and torch angles, joint prep and welding symbols easy to explain and easy for students to remember.'
}, {
  title: 'Six organized volumes',
  text: '300 visual training pages across every core welding teaching area, from MIG, TIG and stick to prints and inspection, so class prep takes minutes instead of hours.'
}, {
  title: 'Safety & precision built in',
  text: 'Safety-first PPE guidance, AWS-aligned terminology, starting settings charts, step-by-step sequences and ❌/✅ comparisons that reinforce safe, clean technique.'
}, {
  title: 'Ready-to-use drills & assessments',
  text: 'Booth drills, practice coupons, shop projects, quick checks and competency rubrics that keep students engaged and progressing.'
}];
export function InstructorBenefits() {
  return <section className="py-12 bg-[#F3F5F7] border-y border-[#D5DAE0]" data-id="element-174" data-mp="1eleq5fxavckd">
      <div className="max-w-7xl mx-auto px-4" data-id="element-175" data-mp="1sko223eh3kij">
        <div className="text-center mb-7" data-id="element-176" data-mp="1slfnilecw1v3">
          <h2 className="text-[#16191E] font-bold tracking-widest uppercase text-sm" data-id="element-177" data-mp="1sibdh7e7mbwi">
            Why Welding Instructors Choose This Atlas
          </h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-178" data-mp="22h99swhvn9q2">
          {benefits.map((benefit, index) => <motion.article key={benefit.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-[#D5DAE0] p-6 rounded-2xl shadow-sm shadow-[#16191E]/5 flex flex-col" data-id="element-179" data-mp="1xhmw6ly4zrgq" data-mpi={index}>
              <CheckCircle2 size={22} className="text-green-600 mb-3" aria-hidden="true" data-id="element-180" data-mp="1dwsyec91vpp3" />
              <h3 className="font-bold text-[#16191E] text-base mb-2" data-id="element-181" data-mp="1duzo8mz8ancc">{benefit.title}</h3>
              <p className="text-slate-700 text-sm leading-relaxed" data-id="element-182" data-mp="1itszs9uyg49v">{benefit.text}</p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}